var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1763.1 334.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.3 326.1V8.5h130.4c32 0 57 7.9 74.8 23.6 17.8 15.7 26.8 36.5 26.8 62.5 0 22.6-6.9 41.5-20.8 56.8-13.9 15.3-33.5 24.6-58.8 27.9l93.8 146.9h-23.8l-92.9-145.5H29.4v145.5H9.3zm20.1-164.8h109.8c26.2 0 46.3-5.8 60.2-17.4 13.9-11.6 20.8-28.1 20.8-49.4 0-21.4-6.9-37.8-20.8-49.4-13.9-11.6-33.9-17.4-60.2-17.4H29.4v133.6zM311.3 326.1V8.5h214.2v19.2h-194v125.4H509v19.2H331.4v134.6h195.9v19.2h-216zM827.5 326.1l-44.4-104.8H623.9L580 326.1h-21.5L692.1 8.5h23.3L850 326.1h-22.5zm-124-293.8l-71.4 169.8h142.8L703.5 32.3zM898 326.1V8.5h20.1v298.4h177.6v19.2H898zM1147 326.1V8.5h20.1v317.6H1147zM1216.1 27.7V8.5h254.5v19.2h-117.2v298.4h-20.1V27.7h-117.2zM1607.4 326.1V201.2L1481.1 8.5h24.3l112.1 173.9L1730 8.5h23.8l-126.3 192.7v124.9h-20.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReality);
export default __webpack_public_path__ + "static/media/reality.9c3186f2.svg";
export { ForwardRef as ReactComponent };